import proj4 from 'proj4'
import {Map as olMap, View as olView} from 'ol'
import {Tile as ollayerTile} from 'ol/layer'
import TileGrid from 'ol/tilegrid/TileGrid'
import {register} from 'ol/proj/proj4'
import {XYZ as olsourceXYZ} from 'ol/source'
import 'ol-proj'
import { Coordinate } from 'ol/coordinate'
import { Extent } from 'ol/extent'
import { Renderer } from './Renderer'

export class OSRenderer extends Renderer<olsourceXYZ> {
  tilegrid: TileGrid
  layer: ollayerTile<olsourceXYZ>
  map: olMap
  projection = "EPSG:27700"

  static IsValidForExtent(latLngExtent: Extent) {
    return !(latLngExtent[0] > 2 || latLngExtent[1] > 61 || latLngExtent[2] < -9 || latLngExtent[3] < 49)
  }

  constructor(type: string, element: string, extentLatLng: Extent, osApiKey: string) {
    super(type)
    const serviceUrl = 'https://api.os.uk/maps/raster/v1/zxy';

    // Setup the EPSG:27700 (British National Grid) projection.
    proj4.defs("EPSG:27700", "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs");
    register(proj4);

    this.tilegrid = new TileGrid({
      resolutions: [896.0, 448.0, 224.0, 112.0, 56.0, 28.0, 14.0, 7.0, 3.5, 1.75],
      origin: [-238375.0, 1376256.0]
    });
    this.layer = new ollayerTile({
      source: new olsourceXYZ({
        url: serviceUrl + `/Leisure_27700/{z}/{x}/{y}.png?key=${osApiKey}`,
        projection: this.projection,
        tileGrid: this.tilegrid
      })
    })

    this.map = this.CreateMap(element, extentLatLng);
  }

  CreateView(centre: Coordinate): olView {
    return new olView({
      projection: this.projection,
      resolutions: this.tilegrid.getResolutions(),
      minZoom: 0,
      maxZoom: 9,
      center: centre
    })
  }
}